import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { caminoService } from '@/services/camino.service';
import type { CaminoUpdateRequest } from '@/types/camino';

export const useCamino = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CAMINO, churchId],
    queryFn: () => caminoService.getCamino(churchId ?? ''),
    enabled: !!churchId,
  });
};

export const useUpdateCaminoMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CaminoUpdateRequest) => caminoService.updateCamino(churchId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CAMINO, churchId] });
      showNotification({ title: 'Success', message: 'Camino updated successfully', color: 'green' });
    },
  });
};
